export default __webpack_public_path__ + "static/media/687.94c5e98a.png";